/* eslint-disable */

import React, { useEffect, useState } from "react";
import { Row, Col, Table, Skeleton, Card, notification } from "antd";
import "./page-css/News.css";
import Banner from "../components/Banner";
import { useSelector } from "react-redux";
import * as Constant from "../config/Constant";
import * as API from "../config/apiConfig";

const Shopping = () => {
  const { menuItem, langId } = useSelector((state) => state.menu);
  const [loading, setLoading] = useState(false);
  const [shoppingList, setShoppingList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const pageSize = 50;

  useEffect(() => {
    fetchShoppingList(currentPage);
  }, [currentPage, langId]);

  const fetchShoppingList = async (page) => {
    setLoading(true);
    try {
      const response = await API.getShoppingList(page, pageSize);
      if (response && response.data) {
        // API returns data in 'response' field with 'count' field
        const data = response.data.response || response.data.data || response.data;
        const total = response.data.count || response.data.total || data.length;
        
        // Add key for table rows
        const formattedData = Array.isArray(data) 
          ? data.map((item, index) => ({
              ...item,
              key: item.id || index,
            }))
          : [];

        setShoppingList(formattedData);
        setTotalItems(total);
      }
    } catch (error) {
      console.error("Error fetching shopping list:", error);
      notification.error({
        message: langId === "2" ? "Lỗi" : "Error",
        description:
          langId === "2"
            ? "Không thể tải danh sách mua sắm"
            : "Cannot load shopping list",
      });
    } finally {
      setLoading(false);
    }
  };

  const handleTableChange = (pagination) => {
    setCurrentPage(pagination.current);
  };

  const handleDownload = async (id, linkDownload) => {
    try {
      const response = await API.downloadShopping(id);
      
      // Get content type from response headers
      const contentType = response.headers['content-type'] || 'application/octet-stream';
      
      // Extract filename from link_download
      let filename = 'download';
      if (linkDownload) {
        const parts = linkDownload.split('/');
        filename = parts[parts.length - 1];
      }
      
      // Create blob with correct content type
      const blob = new Blob([response.data], { type: contentType });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error downloading file:", error);
      notification.error({
        message: langId === "2" ? "Lỗi" : "Error",
        description:
          langId === "2"
            ? "Không thể tải file"
            : "Cannot download file",
      });
    }
  };

  const columns = [
    {
      title: langId === "2" ? "TÊN GÓI MUA SẮM" : "TITLE",
      dataIndex: "title",
      key: "title",
      onHeaderCell: () => ({
        style: {
          backgroundColor: "#0076a7",
          color: "#fff",
          fontWeight: "bold",
          textTransform: "uppercase",
        },
      }),
      render: (text) => (
        <div style={{ fontWeight: "bold", textAlign: "left" }}>{text}</div>
      ),
    },
    {
      title: langId === "2" ? "NỘI DUNG CUNG CẤP" : "DESCRIPTION",
      dataIndex: "description",
      key: "description",
      onHeaderCell: () => ({
        style: {
          backgroundColor: "#0076a7",
          color: "#fff",
          fontWeight: "bold",
          textTransform: "uppercase",
        },
      }),
      render: (text) => text || "-",
    },
    {
      title: langId === "2" ? "LOẠI HỢP ĐỒNG" : "CONTRACT TYPE",
      dataIndex: "contract_type",
      key: "contract_type",
      width: 160,
      onHeaderCell: () => ({
        style: {
          backgroundColor: "#0076a7",
          color: "#fff",
          fontWeight: "bold",
          textTransform: "uppercase",
        },
      }),
      render: (text) => text || "-",
    },
    {
      title: langId === "2" ? "NGÀY PHÁT HÀNH" : "ISSUE DATE",
      dataIndex: "issue_date",
      key: "issue_date",
      width: 140,
      onHeaderCell: () => ({
        style: {
          backgroundColor: "#0076a7",
          color: "#fff",
          fontWeight: "bold",
          textTransform: "uppercase",
        },
      }),
      render: (text) => {
        if (text) {
          const date = new Date(text);
          const day = String(date.getDate()).padStart(2, '0');
          const month = String(date.getMonth() + 1).padStart(2, '0');
          const year = date.getFullYear();
          return `${day}/${month}/${year}`;
        }
        return "-";
      },
    },
    {
      title: langId === "2" ? "THỜI GIAN NHẬN HỒ SƠ" : "DOCUMENT RECEIPT TIME",
      dataIndex: "document_receipt_time",
      key: "document_receipt_time",
      width: 180,
      onHeaderCell: () => ({
        style: {
          backgroundColor: "#0076a7",
          color: "#fff",
          fontWeight: "bold",
          textTransform: "uppercase",
        },
      }),
      render: (text) => {
        if (text) {
          const date = new Date(text);
          const day = String(date.getDate()).padStart(2, '0');
          const month = String(date.getMonth() + 1).padStart(2, '0');
          const year = date.getFullYear();
          return `${day}/${month}/${year}`;
        }
        return "-";
      },
    },
    {
      title: langId === "2" ? "TẢI VỀ" : "DOWNLOAD",
      dataIndex: "link_download",
      key: "link_download",
      width: 120,
      align: "center",
      onHeaderCell: () => ({
        style: {
          backgroundColor: "#0076a7",
          color: "#fff",
          fontWeight: "bold",
          textTransform: "uppercase",
        },
      }),
      render: (text, record) => {
        if (record.id && record.link_download) {
          return (
            <span
              onClick={() => handleDownload(record.id, record.link_download)}
              style={{
                display: "inline-block",
                padding: "4px 12px",
                background: "#FFA500",
                color: "#fff",
                borderRadius: "2px",
                cursor: "pointer",
              }}
            >
              ⬇
            </span>
          );
        }
        return "-";
      },
    },
    {
      title: langId === "2" ? "NGÀY ĐĂNG" : "DATE",
      dataIndex: "published_date",
      key: "published_date",
      width: 120,
      onHeaderCell: () => ({
        style: {
          backgroundColor: "#0076a7",
          color: "#fff",
          fontWeight: "bold",
          textTransform: "uppercase",
        },
      }),
      render: (text) => {
        if (text) {
          const date = new Date(text);
          const day = String(date.getDate()).padStart(2, '0');
          const month = String(date.getMonth() + 1).padStart(2, '0');
          const year = date.getFullYear();
          return `${day}/${month}/${year}`;
        }
        return "-";
      },
    },
    {
      title: langId === "2" ? "GHI CHÚ" : "NOTE",
      dataIndex: "notes",
      key: "notes",
      onHeaderCell: () => ({
        style: {
          backgroundColor: "#0076a7",
          color: "#fff",
          fontWeight: "bold",
          textTransform: "uppercase",
        },
      }),
      render: (text, record) => text || record?.notes || record?.remark || "-",
    },
  ];

  return (
    <Row className="news-wrapper" style={{ minHeight: "70vh" }}>
      <Banner
        title={menuItem.title || (langId === "2" ? "Mua sắm" : "Shopping")}
        className="banner-wrapper"
        cover={
          menuItem.banner
            ? `${Constant.IMAGES_URL}${menuItem.banner}`
            : undefined
        }
      />
      
      <Row style={{ width: "100%", padding: "20px 0" }}>
        <Col offset={3} span={18}>
          <Card bordered={false}>
            <Skeleton loading={loading} active={loading}>
              <Table
                dataSource={shoppingList}
                columns={columns}
                pagination={{
                  current: currentPage,
                  pageSize: pageSize,
                  total: totalItems,
                  showSizeChanger: false,
                  showTotal: (total, range) =>
                    langId === "2"
                      ? `${range[0]}-${range[1]} của ${total} mục`
                      : `${range[0]}-${range[1]} of ${total} items`,
                }}
                onChange={handleTableChange}
                loading={loading}
                bordered
                scroll={{ x: "100%" }}
              />
            </Skeleton>
          </Card>
        </Col>
      </Row>
    </Row>
  );
};

export default Shopping;
